export default {
  dataComponents: {
    actions: 'Actions',
    all: 'All',
    apply: 'Apply',
    back: 'Back',
    between: 'Between',
    betweenCriteria: 'Between {0} and {1}',
    cancel: 'Cancel',
    changed: 'Changed',
    clear: 'Clear',
    clearSearch: 'Clear search',
    clearSearchInput: 'Clear search input',
    close: 'Close',
    column: { none: 'No items found', search: 'Search' },
    columns: 'Columns',
    contains: 'Contains',
    datepicker: 'Datepicker',
    default: 'Default',
    delete: 'Delete',
    deleteThisView: 'Delete this view?',
    display: 'Display',
    dragHandleLabel: '{0} drag handle',
    emptyHeader: 'No views available',
    enterMax: 'Enter Maximum',
    enterMin: 'Enter Minimum',
    equals: 'Equals',
    filter: 'Filter',
    filters: 'Filters',
    findColumnByName: 'Find Column By Name',
    from: 'from',
    greaterThan: 'Greater than',
    greaterThanOrEqual: 'Greater than or Equal',
    hidden: 'Hidden',
    hideAll: 'Hide All',
    hideValues: 'Hide Values',
    itemsSelected: '{0} Items selected',
    isGreaterThan: 'Is greater than',
    isLessThan: 'Is less than',
    left: 'Left',
    lessThan: 'Less than',
    lessThanOrEqual: 'Less than or Equal',
    maxPrimary: 'Max of {0}',
    newViewSaved: 'New view saved',
    next: 'Next',
    no: 'No',
    noResultsFound: 'No results found',
    numberFilterType: 'Number Filter Type',
    numberInput: 'Number Input',
    notEqual: 'Not Equal',
    pin: 'Pin',
    pinColumnLeft: 'Pin column left',
    pinColumnRight: 'Pin column right',
    previous: 'Previous',
    refresh: 'Refresh',
    remove: 'Remove',
    rename: 'Rename',
    resultsFor: 'Results for:{0}',
    right: 'Right',
    save: 'Save',
    saveAs: 'Save As',
    select: 'Select',
    selectAll: 'Select all',
    setDefault: 'Set Default',
    showValues: 'Show Values',
    startsWith: 'Starts with',
    to: 'to',
    unpin: 'Unpin',
    unpinAllColumns: 'Unpin all columns',
    unpinColumn: 'Unpin column',
    viewName: 'View Name',
    viewOf: 'View {0} of {1}',
    xHidden: '{0} Hidden',
    viewPageOf: 'View page {0} of {1}',
    xVisible: '{0} Visible',
    yes: 'Yes',
    print: 'Print',
    export: 'Export',
    searchInputPlaceholder: 'Search...',
    search: 'Search',
  },
};
